export const maxFileSize = 3 * 1024 * 1024;
export const maxFileSizeMB = maxFileSize / 1024 / 1024;
export const acceptedImageTypes = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/heic',
  'image/gif',
] as const;
